(function() {
  'use strict';
  
  function enhanceSwatches() {
    try {
      const swatchItems = document.querySelectorAll('.t4s-swatch__item');
      swatchItems.forEach(function(swatch) {
        if (swatch.style.backgroundImage && swatch.style.backgroundImage !== 'none') {
          swatch.addEventListener('click', function(e) {
            this.style.transform = 'scale(0.95)';
            setTimeout(() => {
              this.style.transform = '';
            }, 150);
          });
          
          swatch.addEventListener('mouseenter', function() {
            this.style.transform = 'scale(1.05)';
          });
          
          swatch.addEventListener('mouseleave', function() {
            this.style.transform = '';
          });
        }
      });
    } catch (error) {
      console.warn('Swatch enhancement error:', error);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceSwatches);
  } else {
    enhanceSwatches();
  }
  
  if (typeof window !== 'undefined') {
    let observer;
    try {
      observer = new MutationObserver(function(mutations) {
        let shouldEnhance = false;
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            shouldEnhance = true;
          }
        });
        if (shouldEnhance) {
          setTimeout(enhanceSwatches, 100);
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } catch (error) {
      console.warn('MutationObserver not supported:', error);
    }
  }
})(); 